import * as Cesium from "cesium"
import viewerCesiumNavigationMixin from "../../Components/dist";
import getFlagForKeyCode from "./movementFuncs";

const instantiateViewer = async(datasetConf) => {
    Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJiOTY0OTM3Mi1lM2Y5LTQ1ZjctOGFhZS0xYTE0Mzk3ZjFjYzkiLCJpZCI6ODY0MjEsImlhdCI6MTY0NzgyNTk0N30.XAL8QLThMd4-BXPcNPG_AuFeaaDhAYeVT2jRyEOJMkY'
    const viewer = await new Cesium.Viewer(`threeDViewer`, {
        terrainProvider: Cesium.createWorldTerrain(),
          imageryProvider : new Cesium.OpenStreetMapImageryProvider({
              url : 'https://a.tile.openstreetmap.org/'
          }),
        vrButton: true,
        timeline: false,
        animation: false,
    });


    let options = {}
    //options.units = 'miles'
    //options.distanceLabelFormatter = (convertedDistance, units : Units): string => { ... }
    viewer.extend(viewerCesiumNavigationMixin, {options})
    viewer.scene.globe.depthTestAgainstTerrain = false;
    let scene = viewer.scene;
    let canvas = viewer.canvas;
    canvas.height = window.innerHeight * .70
    canvas.setAttribute('tabindex', '0'); // needed to put focus on the canvas
    canvas.onclick = function() {
        canvas.focus();
    };
    let ellipsoid = viewer.scene.globe.ellipsoid;


    scene.screenSpaceCameraController.enableRotate = true;
    scene.screenSpaceCameraController.enableTranslate = true;
    scene.screenSpaceCameraController.enableZoom = true;
    scene.screenSpaceCameraController.enableTilt = true;
    scene.screenSpaceCameraController.enableLook = true;

    let startMousePosition;
    let mousePosition;
    let flags = {
        looking : false,
        moveForward : false,
        moveBackward : false,
        moveUp : false,
        moveDown : false,
        moveLeft : false,
        moveRight : false,
        orbit: false
    };
    let handler = new Cesium.ScreenSpaceEventHandler(canvas);
    
    handler.setInputAction(function(movement) {
        mousePosition = movement.endPosition;
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

    handler.setInputAction(function(position) {
        flags.looking = false;
    }, Cesium.ScreenSpaceEventType.LEFT_UP);

    document.addEventListener('keydown', function(e) {
        let flagName = getFlagForKeyCode(e.keyCode);
        if (typeof flagName !== 'undefined') {
            flags[flagName] = true;
        }
    }, false);

    document.addEventListener('keyup', function(e) {
        let flagName = getFlagForKeyCode(e.keyCode);
        if (typeof flagName !== 'undefined') {
            flags[flagName] = false;
        }
    }, false);

    viewer.clock.onTick.addEventListener(function(clock) {
        let camera = viewer.camera;
        if (flags.looking) {
            let width = canvas.clientWidth;
            let height = canvas.clientHeight;

            // Coordinate (0.0, 0.0) will be where the mouse was clicked.
            let x = (mousePosition.x - startMousePosition.x) / width;
            let y = -(mousePosition.y - startMousePosition.y) / height;

            let lookFactor = 0.05;
            camera.lookRight(x * lookFactor);
            camera.lookUp(y * lookFactor);
        }
//
//        // Change movement speed based on the distance of the camera to the surface of the ellipsoid.
        let cameraHeight = ellipsoid.cartesianToCartographic(camera.position).height;
        let moveRate = cameraHeight / 100.0;

        if (flags.moveForward) {
            camera.moveForward(moveRate);
        }
        if (flags.moveBackward) {
            camera.moveBackward(moveRate);
        }
        if (flags.moveUp) {
            camera.moveUp(moveRate);
        }
        if (flags.moveDown) {
            camera.moveDown(moveRate);
        }
        if (flags.moveLeft) {
            camera.moveLeft(moveRate);
        }
        if (flags.moveRight) {
            camera.moveRight(moveRate);
        }
        //if (flags.orbit){
        //    const transform = Transforms.eastNorthUpToFixedFrame(camera.position);
        //    const range = 5.0;
        //    viewer.camera.lookAtTransform(transform, new HeadingPitchRange(camera.heading, camera.pitch, range));
        //}
    });



    return viewer
}

export default instantiateViewer;
